<a
  class="notification-link"
  (click)="navigate()"
  [innerHTML]="'Query::IndexingNearNotCompletedNotification' | abpLocalization : phrases"></a>
